import { render, staticRenderFns } from "./DetailVoucherSpecial.vue?vue&type=template&id=c35a7dd4&scoped=true"
import script from "./DetailVoucherSpecial.vue?vue&type=script&lang=js"
export * from "./DetailVoucherSpecial.vue?vue&type=script&lang=js"
import style0 from "./DetailVoucherSpecial.vue?vue&type=style&index=0&id=c35a7dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35a7dd4",
  null
  
)

export default component.exports